"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNestedTokens = exports.isThemeToken = exports.isPlatformToken = exports.isDisplayModeToken = exports.isDisplayWidthToken = void 0;
exports.resolveTokens = resolveTokens;
const map_values_1 = __importDefault(require("@treefort/lib/map-values"));
/**
 * IDENTIFIERS
 *
 * These type guards are used to identify particular token types
 */
const isDisplayWidthToken = (tokens) => typeof tokens === "object" && "_resolveWithDisplayWidth" in tokens;
exports.isDisplayWidthToken = isDisplayWidthToken;
const isDisplayModeToken = (tokens) => typeof tokens === "object" && "_resolveWithDisplayMode" in tokens;
exports.isDisplayModeToken = isDisplayModeToken;
const isPlatformToken = (tokens) => typeof tokens === "object" && "_resolveWithPlatform" in tokens;
exports.isPlatformToken = isPlatformToken;
const isThemeToken = (tokens) => typeof tokens === "object" && "_resolveWithTheme" in tokens;
exports.isThemeToken = isThemeToken;
const isNestedTokens = (tokens) => typeof tokens === "object" &&
    !Object.keys(tokens).some((key) => key.startsWith("_resolveWith"));
exports.isNestedTokens = isNestedTokens;
/**
 * RESOLVERS
 *
 * These functions take source tokens and resolve any dynamic tokens found
 * within them. All functions have the same signature so that they are easy to
 * compose and are recursive-friendly. Only the final `resolveTokens` function
 * should be used outside this module.
 */
function resolveDisplayWidthToken(tokens, props) {
    const widths = Object.keys(tokens)
        .map((k) => parseInt(k))
        .filter((w) => !isNaN(w))
        .sort((a, b) => a - b);
    let closestWidth = 0;
    for (const width of widths) {
        if (props.displayWidth >= width) {
            closestWidth = width;
        }
    }
    return tokens[closestWidth];
}
function resolveDisplayModeToken(tokens, props) {
    return resolveTokens(tokens[props.displayMode], props);
}
function resolveNestedTokens(tokens, props) {
    return (0, map_values_1.default)(tokens, (value) => resolveTokens(value, props));
}
function resolvePlatformToken(tokens, props) {
    const { platform } = props;
    const token = platform in tokens
        ? tokens[platform]
        : (platform === "ios" || platform === "android") && "native" in tokens
            ? tokens.native
            : tokens.default;
    return resolveTokens(token, props);
}
function resolveThemeToken(tokens, props) {
    return props.theme[tokens.property];
}
function resolveTokens(tokens, props) {
    if ((0, exports.isDisplayWidthToken)(tokens)) {
        return resolveDisplayWidthToken(tokens, props);
    }
    else if ((0, exports.isDisplayModeToken)(tokens)) {
        return resolveDisplayModeToken(tokens, props);
    }
    else if ((0, exports.isPlatformToken)(tokens)) {
        return resolvePlatformToken(tokens, props);
    }
    else if ((0, exports.isThemeToken)(tokens)) {
        return resolveThemeToken(tokens, props);
    }
    else if ((0, exports.isNestedTokens)(tokens)) {
        return resolveNestedTokens(tokens, props);
    }
    else {
        return tokens;
    }
}
